import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import ModalConfirm from '~/commons/components/ModalConfirm.jsx';

const BtnDel = ({
  api,
  onDel = () => {},
  message,
  theme,
}) => {
  const [res, req] = useHttpStatus();
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <ModalConfirm
        show={showModal}
        theme={theme}
        onReject={() => setShowModal(false)}
        onConfirm={async () => {
          setShowModal(false);

          await req({
            method: 'delete',
            ...api,
          });

          onDel();
        }}
      >
        {message || t('Are you sure you want to delete?')}
      </ModalConfirm>
      <FormHttpBtn
        className="btn btn-outline-primary"
        type="button"
        res={res}
        icon={faTrashAlt}
        onClick={() => setShowModal(true)}
      >
        {t('Delete')}
      </FormHttpBtn>
    </>
  );
};

export default BtnDel;
